<template>
  <div class="helmi-canceling">
    <h2 class="text-h5 mb-2">
      Peruuttamislomake
    </h2>
    <v-card class="mb-4">
      <v-col class="py-4">
        <p>
          Peruuttamisoikeus (Kuluttajansuojalaki 6 luku (30.12.2013/1211) (Kotimyynti ja etämyynti)
        </p>
        <v-select
          v-model="canceling.selectedAgent"
          :items="agents"
          item-text="name"
          return-object
          label="Peruutuksen vastaanottaja"
          hide-details
          outlined
        />
      </v-col>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { apiGet } from '../../api';

export default {
  props: {
    canceling: {
      type: Object,
      default: () => ({
        selectedAgent: {},
      }),
    },
  },
  data: () => ({
    agents: [],
  }),
  computed: {
    ...mapGetters({
      userDetails: 'userDetails',
    }),
  },
  async mounted() {
    const agentResponse = await apiGet('agent/getAgents');
    this.agents = agentResponse.result.map(agent => ({
      id: agent.id,
      name: agent.nimi,
      phone: agent.puhelin,
      email: agent.email,
      address: agent.address,
      companyName: agent.companyName,
    }));
    if (!this.canceling.selectedAgent.name) {
      this.canceling.selectedAgent = this.agents.find(a => a.name === this.userDetails.nimi);
    }
  },
};
</script>
<style lang="scss">
.helmi-canceling {
  max-width: 1024px;
}
</style>
